<div
  class="cash-points-slider-container rounded-md flex px-8 py-4"
  [ngClass]="{
    'flex-col': sliderConfig.sliderLabelPosition === 'top',
    'flex-row': sliderConfig.sliderLabelPosition === 'sides',
    'items-center': sliderConfig.sliderLabelPosition === 'sides'
  }">
  <ng-container [ngSwitch]="sliderConfig.sliderLabelPosition">
    <ng-container *ngSwitchCase="'top'">
      <div class="slider-labels">
        <span class="slider-label">{{
          sliderConfig.sliderPointsLabel | translate
        }}</span>
        <span class="slider-label">{{
          sliderConfig.sliderCashLabel | translate
        }}</span>
      </div>
      <div class="slider-content pb-4">
        <ascenda-ngx-slider
          [options]="ngxSliderOptions"
          (valueChange)="onInputChange($event)"></ascenda-ngx-slider>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'sides'">
      <span class="slider-label">{{
        sliderConfig.sliderPointsLabel | translate
      }}</span>
      <div class="slider-content max-w-[709px] flex-1 px-4">
        <ascenda-ngx-slider
          [options]="ngxSliderOptions"
          (valueChange)="onInputChange($event)"></ascenda-ngx-slider>
      </div>
      <span class="slider-label">{{
        sliderConfig.sliderCashLabel | translate
      }}</span>
    </ng-container>
  </ng-container>
</div>
